import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/** Shared layout for legal pages — Privacy, Terms, Refunds, Contact. */
export default function LegalPage({ title, lastUpdated, children, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#FBF9F6] flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 w-full">
        <p className="text-xs uppercase tracking-[0.3em] text-[#9A938A] mb-3">
          Legal
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#2D2926] tracking-tight">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-2 text-xs text-[#9A938A]">
            Last updated: {lastUpdated}
          </p>
        )}
        <div className="mt-10 space-y-8 text-[#3D3833] leading-relaxed text-[15px] legal-prose">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
